import {useState, useEffect, FC} from "react"
import loginLoaderStyles from "./loginLoader.module.scss"

export const LoginLoader: FC<{
    showLoadingText?: boolean
    loadingText?: string
}> = ({
    showLoadingText = true,
    loadingText = "Loading..."
}) => {
    const styles = loginLoaderStyles
    return <>
      <div>
        {showLoadingText ? <>
            <h2 className={styles["loading-label"]}>
                {loadingText}
            </h2>
        </> : <></>}
        <div className={styles["loading-boxes"]}>
          <div className={styles["loading-box"]}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className={styles["loading-box"]}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className={styles["loading-box"]}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className={styles["loading-box"]}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </>
}

export const LoadingOverlay: FC<{
    loading: boolean,
    minimumLoadTime?: number
    showLoadingText?: boolean
    loadingText?: string
}> = ({
    children,
    loading,
    minimumLoadTime = 0,
    showLoadingText = true,
    loadingText = "Loading..."
}) => {
    const [destroyLoadingOverlay, SetDestroyLoadingOverlay] = useState(false)

    useEffect(() => {
        const timer = window.setTimeout(() => {
            SetDestroyLoadingOverlay(true)
        }, minimumLoadTime)
        return () => window.clearTimeout(timer)
    }, [])
    return <>
        {
            loading || !destroyLoadingOverlay ?
                <div className="w-full h-full flex items-center flex-col justify-center">
                    <LoginLoader 
                        showLoadingText={showLoadingText}
                        loadingText={loadingText}
                    />
                </div> : <>
                    { children }
                </>
        }
    </> 
}

export const LoadingFullscreenOverlay: FC<{
    loading: boolean,
    minimumLoadTime?: number
    showLoadingText?: boolean
    loadingText?: string
}> = ({
    children,
    loading,
    minimumLoadTime = 0,
    showLoadingText = true,
    loadingText = "Loading..."
}) => {
    const [destroyLoadingOverlay, SetDestroyLoadingOverlay] = useState(false)

    useEffect(() => {
        const timer = window.setTimeout(() => {
            SetDestroyLoadingOverlay(true)
        }, minimumLoadTime)
        return () => window.clearTimeout(timer)
    }, [])
    return <>
        {
            loading || !destroyLoadingOverlay ?
                <div className="w-screen h-screen fixed top-0 left-0 flex items-center justify-center">
                    <div>
                        <LoginLoader 
                            showLoadingText={showLoadingText}
                            loadingText={loadingText}
                        />
                    </div>
                </div> : <>
                    { children }
                </>
        }
    </> 
}